import React from 'react';

import Box from '@deliveryhero/pd-cookbook/components/Box';
import { Message } from '@deliveryhero/pd-cookbook/components/Message';
import { CsvUpload } from 'src/components/CsvUpload';
import { CsvColumn } from 'src/components/CsvUpload/types';

import './style.scss';

export const BulkDeleteEmployee = (props: {
  handleUpload: (file: File) => void;
  config: Configuration | Record<string, never>;
  warning: string;
  successMessageMultiple: string;
  successMessageSingle: string;
  errorMessage: string;
}) => {
  const {
    handleUpload,
    config,
    warning,
    successMessageMultiple,
    successMessageSingle,
    errorMessage
  } = props;

  const templateEndpoint = '/company-portal/users/delete-template';
  const column: CsvColumn = {
    key: 'email',
    label: 'Work Email',
    required: true
  };
  const fileHandler = (file: File | null, validRows: number) => {
    if (file != null) {
      handleUpload(file as File);
    }
  };
  return (
    <div className="container">
      <CsvUpload
        config={config as Configuration}
        templateEndpoint={templateEndpoint}
        columns={[column]}
        fileHandlerCallback={fileHandler}
        successMessageMultiple={successMessageMultiple}
        successMessageSingle={successMessageSingle}
        errorMessage={errorMessage}
      />
      <Box marginTop="xxl">
        <Message message={warning} kind="warning" />
      </Box>
    </div>
  );
};
